export default "__VITE_ASSET__COiObPSV__ 300w";